import 'bootstrap/dist/css/bootstrap.min.css'
import Landing from './Pages/Landing'
import Dashboard from './Pages/Dashboard/Dashboard'
import Nodashboard from './Pages/Nodashboard/Nodashboard'
import Cancel from './Pages/Redirects/Cancel'
import Success from './Pages/Redirects/Success'
import Navbar from './Components/Navbar/Navbar'
import Register from './Pages/Register/Register'
import Login from './Pages/Login/Login'
import Terms from './Pages/Legal/Terms/Terms'
import Privacy from './Pages/Legal/Privacy/Privacy'
import Analytics from './Pages/Analytics/Analytics'
import { ToastProvider } from 'react-toast-notifications'
import "@stripe/stripe-js"

import Announcement from './Components/Announcement/Announcement'

import React, { useContext } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import AuthContext from "./Store/auth-context";

function App() {
    const authCtx = useContext(AuthContext);
    return (
        <ToastProvider>
            <Router>
                <Switch>
                    <Route path="/games/:id">
                        {authCtx.isActive && <Dashboard />}
                    </Route>

                    <Route path="/dashboard">
                        {
                            authCtx.isActive &&
                            <Nodashboard />
                        }
                        {/*{!authCtx.isActive && <Redirect to="/login"/>}*/}
                    </Route>

                    <Route path="/games">
                        <Redirect to='/dashboard' />
                    </Route>

                    <Route path="/login">
                        {authCtx.isLoggedIn && <Redirect to='/' />}
                        <Login />
                    </Route>

                    <Route path="/register">
                        <Navbar />
                        {authCtx.isLoggedIn && <Redirect to='/' />}
                        {!authCtx.isLoggedIn && <Register />}
                    </Route>

                    <Route path="/cancel">
                        <Navbar />
                        <Cancel />
                    </Route>

                    <Route path="/success">
                        <Navbar />
                        <Success />
                    </Route>

                    <Route path="/terms-of-service">
                        <Navbar />
                        <Terms />
                    </Route>

                    <Route path="/privacy-policy">
                        <Navbar />
                        <Privacy />
                    </Route>

                    <Route path="/previous-picks">
                        <Announcement />
                        <Navbar />
                        <Analytics />
                    </Route>

                    <Route path="/">
                        <Landing />
                    </Route>
                </Switch>
            </Router>
        </ToastProvider>
    );
}

export default App;
